import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const startupPacketApi = createApi({
  baseQuery,
  reducerPath: 'startupPacketApi',
  endpoints: builder => ({
    getContractBudgetData: builder.query<any, any>({
      query: ({ site_id, study_id, country, application }) => ({
        url: `${formatString(
          endPoints.Budget.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createContractBudget: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Budget.create,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'POST',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateContractBudget: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, data }) => ({
        url: `${formatString(
          endPoints.Budget.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${application}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    })
  })
});

export const { useGetContractBudgetDataQuery, useCreateContractBudgetMutation, useUpdateContractBudgetMutation } =
  startupPacketApi;
